module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ahead0-0e9801d6d787a50c87f8d18ca1a01edf.jpg";